import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
  selector: 'loyaltic-join-tournament',
  templateUrl: './join-tournament.component.html',
  styleUrls: ['./join-tournament.component.scss']
})
export class JoinTournamentComponent implements OnInit {

  inviteCode = '';
  userId = '';
  uniqueCode = '';
  tournamentId = localStorage.getItem('tournamentId');

  constructor(private readonly coreService: CoreService, 
    private readonly authService: AuthService,
    private readonly router: Router, private readonly translate: TranslateService, private readonly toast: ToastrService) { }

  ngOnInit() {
    this.userId = this.authService.getUserId();
  }

  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    this.uniqueCode = pastedText;
  }

  onSubmit(form) {
    form.submitted = false;
    this.coreService.joinTournament(this.userId, this.tournamentId, this.inviteCode).then((response:any) => {
      if (response.messageKey == 'invalid-code') {
        this.toast.error(this.translate.instant('invalid-code'), 'Error');
      } else {
        localStorage.removeItem('tournamentId');
        this.toast.success(this.translate.instant('tournament-joined'), this.translate.instant('success'));
        this.router.navigateByUrl('/tournament-list');
      }
      
    }, (error:any) => {
      //this.tra
    })
  }

}
